import { createRef, FC } from 'react'
import { Form, SelectPicker } from 'rsuite';
import { SelectOptions } from 'core/models/Settings'

interface Meta {
  touched: boolean;
  error: string;
}

interface ComponentProps {
  input: any;
  placeholder: string;
  meta?: Meta;
  options: SelectOptions[];
  label?: string;
  searchable: boolean;
  disabled?: boolean;
  cleanable?: boolean;
  groupBy?: string;
  disabledItemValues?: string[];
  containerRef: any;
  name?: string;
}

const CustomSelect: FC<ComponentProps> = ({ placeholder, input, options, searchable, disabled, cleanable, groupBy, disabledItemValues, containerRef }) => (
  <SelectPicker
    searchable={searchable}
    block
    placeholder={placeholder}
    data={options}
    menuMaxHeight={140}
    value={input.value}
    disabled={disabled}
    onChange={(value: any) => input.onChange(value)}
    cleanable={cleanable}
    groupBy={groupBy}
    disabledItemValues={disabledItemValues}
    container={() => containerRef.current}
  />
)

const Select: FC<ComponentProps> = (props: ComponentProps) => {
  const {
    placeholder = "Select",
    meta,
    input,
    label,
    options,
    searchable = true,
    disabled,
    cleanable = true,
    groupBy = '',
    disabledItemValues = [],
    name = 'select-picker',
  } = props
  const divRef = createRef<HTMLDivElement>();
  return (
    <Form.Group controlId='select'>
      <Form.ControlLabel>{label}</Form.ControlLabel>
      <div style={{ position: 'relative' }} ref={divRef} >
        <Form.Control
          name={`${name}-form-control`}
          input={input}
          accepter={CustomSelect}
          placeholder={placeholder}
          options={options}
          searchable={searchable}
          cleanable={cleanable}
          disabled={disabled}
          groupBy={groupBy}
          disabledItemValues={disabledItemValues}
          errorMessage={meta?.touched && meta.error}
          containerRef={divRef}
        />
      </div>
    </Form.Group>
  );
}

export default Select